/* 🤖 this file was generated by svg-to-ts */
export const sbIconsChevronRight: {
  name: 'chevron-right';
  data: string;
} = {
  name: 'chevron-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="M15.3502 8.6513 7.26306.56419A1.9073 1.9073 0 0 0 5.90885 0a1.9074 1.9074 0 0 0-1.35421.56419 1.90735 1.90735 0 0 0 0 2.68934l6.75196 6.75197-6.75196 6.752A1.9075 1.9075 0 0 0 4 18.1022c0 .5039.1994.9873.55464 1.3446.17822.1768.38959.3167.62197.4116s.48122.143.73224.1416a1.909 1.909 0 0 0 .73224-.1416 1.907 1.907 0 0 0 .62197-.4116l8.08714-8.0871c.1787-.1773.3206-.3882.4175-.6207.0968-.2324.1467-.4817.1467-.7335a1.908 1.908 0 0 0-.1467-.7335 1.91 1.91 0 0 0-.4175-.6207"/></svg>`
};
